//Copyright (c) 2022 Panshak Solomon

import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import SnackbarProvider from "react-simple-snackbar";
import Home from "./components/Home/Home";
import Invoice from "./components/Invoice/Invoice";
import Invoices from "./components/Invoices/Invoices";
import CreditInvoices from "./components/Invoices/CreditInvoices";
import InvoiceDetails from "./components/InvoiceDetails/InvoiceDetails";
import ClientList from "./components/Clients/ClientList";
import SupplierList from "./components/Suppliers/SuppliersList";
import StaffList from "./components/Staff/StaffList";
import NavBar from "./components/NavBar/NavBar";
import Login from "./components/Login/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Settings from "./components/Settings/Settings";
import Forgot from "./components/Password/Forgot";
import Reset from "./components/Password/Reset";
import Calendar from "./components/Meetings/Calendar";
import ItemsList from "./components/Items/ItemsList";
import MeetingForm from "./components/Meetings/MeetingForm";
import Meetings from "./components/Meetings/Meetings";
import AdminLogin from "./admin/adminLogin/adminLogin";
import AdminDashboard from "./admin/adminDashboard";
import AdminProfiles from "./admin/adminProfiles";
import Stats from "./admin/stats";
import UserStats from "./admin/userStats";
import PrivacyPolicy from "./components/PrivacyPolicy";
import PosMainScreen from "./PoS/PosMainScreen";
import StockDetails from "./stock/StockDetails";
import Purchase from "./components/Purchase/Purchase";
import PurchaseDetails from "./components/PurchaseDetails/PurchaseDetails";
import Purchases from "./components/Purchases/Purchases";
import StockAdjustment from "./stock/StockAdjustment/StockAdjustment";
import StockAdjustmentDetails from "./stock/StockAdjustmentDetails/StockAdjustmentDetails";
import StockAdjustments from "./stock/StockAdjustments/StockAdjustments";
import HowItWorks from "./components/HowItWorks/HowItWorks";
import EditStaff from "./components/Staff/EditStaff";
import StaffStats from "./admin/StaffStats";
import Statement from "./admin/adminLogin/Statement";
import UnitsList from "./components/Items/units/unitsList";
import StaffCommission from "./components/Staff/StaffCommission";
import InvoiceDeleteHistory from "./components/Invoices/InvoiceDeleteHistory";
import InvoiceCancelHistory from "./components/Invoices/InvoiceCancelHistory";
import BulkItemUpload from "./components/Items/BulkItemUpload";
import BulkItemEdit from "./components/Items/BulkItemEdit";
import FuturePriceList from "./components/Items/FuturePriceList";
import FuturePriceListView from "./components/Items/FuturePriceListView";
import LowStockPage from "./components/Dashboard/LowStockPage";
import SupplierDues from "./components/Suppliers/SupplierDues";
import  {  useEffect } from 'react';
import './app.css';
import CashManagement from "./components/CashManagement/CashManagement";
import QrScanner from "./components/InvoiceDetails/QrScanner";
import ComplimentaryHistory from "./components/Invoices/ComplimentaryHistory";
import BogieMaster from "./components/BogieMaster";
import QrScanReport from "./components/QrScanReport/QrScanReport";

// import { requestFirebaseNotificationPermission } from './firebaseInit'

// import AdminOrders from './admin/adminOrders';
function App() {
  const user = JSON.parse(localStorage.getItem("profile"));
  // requestFirebaseNotificationPermission()
  //   .then((firebaseToken) => {
  //     // eslint-disable-next-line no-console
  //     console.log(firebaseToken);
  //   })
  //   .catch((err) => {/edit/invoice/
  //     return err;
  //   });
  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage');
    if (savedLanguage && savedLanguage !== 'en') {
      const applyLanguage = (attempts = 5) => {
        const selectElement = document.querySelector('.goog-te-combo');
        if (selectElement) {
          selectElement.value = savedLanguage;
          selectElement.dispatchEvent(new Event('change'));
        } else if (attempts > 0) {
          setTimeout(() => applyLanguage(attempts - 1), 500);
        }
      };
      applyLanguage();
    }
  }, []);

  return (
    <div>
      <BrowserRouter>
        <SnackbarProvider>
          {user && !window.location.href.includes("/PosMainScreen") && (
            <NavBar />
          )}

          <Header />
          <Switch>
            <Route path="/login" exact component={Login} />
            <Route path="/forgot" exact component={Forgot} />
            <Route path="/reset/:token" exact component={Reset} />

            <Route path="/" exact component={Login} />
            {user && <Route path="/invoice" exact component={Invoice} />}
            {user && <Route path="/qr-scanner" exact component={QrScanner} />}
            {user && (
              <Route path="/edit/invoice/:id" exact component={PosMainScreen} />
            )}
            {user && (
              <Route path="/invoice/:id" exact component={InvoiceDetails} />
            )}
            {user && <Route path="/invoices" exact component={Invoices} />}
            {user && (
              <Route path="/invoices/credit" exact component={CreditInvoices} />
            )}
            {user && <Route path="/low-stock" exact component={LowStockPage} />}
            {user && <Route path="/bogie-master" exact component={BogieMaster} />}
            {user && (
              <Route
                path="/invoices/deleted"
                exact
                component={InvoiceDeleteHistory}
              />
            )}

            {user && (
              <Route
                path="/invoices/canceled"
                exact
                component={InvoiceCancelHistory}
              />
            )}
            {user && (
              <Route path="/invoices/complimentary" exact component={ComplimentaryHistory} />
            )}

            {user && (
              <Route path="/stockDetails" exact component={StockDetails} />
            )}

            {user && <Route path="/purchase" exact component={Purchase} />}
            {user && (
              <Route path="/edit/purchase/:id" exact component={Purchase} />
            )}
            {user && (
              <Route path="/purchase/:id" exact component={PurchaseDetails} />
            )}
            {user && <Route path="/purchases" exact component={Purchases} />}

            {user && (
              <Route
                path="/stockAdjustment"
                exact
                component={StockAdjustment}
              />
            )}
            {user && (
              <Route
                path="/edit/stockAdjustment/:id"
                exact
                component={StockAdjustment}
              />
            )}
            {user && (
              <Route
                path="/stockAdjustment/:id"
                exact
                component={StockAdjustmentDetails}
              />
            )}
            {user && (
              <Route
                path="/stockAdjustments"
                exact
                component={StockAdjustments}
              />
            )}

            {user && <Route path="/admin" exact component={AdminLogin} />}
            {user && <Route path="/settings" exact component={Settings} />}
            {user && <Route path="/dashboard" exact component={Dashboard} />}
            {user && (
              <Route path="/adminDashboard" exact component={AdminDashboard} />
            )}
            {user && (
              <Route path="/adminProfiles" exact component={AdminProfiles} />
            )}

            {user && <Route path="/stats/:clientId" exact component={Stats} />}

            {user && (
              <Route path="/userStats/:userId" exact component={UserStats} />
            )}
            {user && (
              <Route path="/staffstats/:staffId" exact component={StaffStats} />
            )}
            {user && <Route path="/meetings" exact component={Meetings} />}
            {user && <Route path="/help" exact component={HowItWorks} />}
            {user && <Route path="/customers" exact component={ClientList} />}
            {user && <Route path="/suppliers" exact component={SupplierList} />}
            {user && <Route path="/cash-management" exact component={CashManagement} />}
            {user && (
              <Route path="/supplier-dues" exact component={SupplierDues} />
            )}

            {user && (
              <Route path="/edit/staff/:id" exact component={EditStaff} />
            )}
            {user && <Route path="/statement" exact component={Statement} />}
            {user && <Route path="/staff" exact component={StaffList} />}
            {user && (
              <Route
                path="/staff/commissionSummary"
                exact
                component={StaffList}
              />
            )}

            {user && <Route path="/ItemsList" exact component={ItemsList} />}
            {user && <Route path="/UnitsList" exact component={UnitsList} />}
            {user && (
              <Route path="/bulk-upload" exact component={BulkItemUpload} />
            )}
            {user && (
              <Route path="/bulk-edit">
                <BulkItemEdit />
              </Route>
            )}
            {user && (
              <Route
                exact
                path="/future-price-list"
                component={FuturePriceList}
              />
            )}
            {user && (
              <Route
                exact
                path="/future-price-list/view"
                component={FuturePriceListView}
              />
            )}

            <Route
              path="/Webview/PrivacyPolicy"
              exact
              component={PrivacyPolicy}
            />
            {user && <Redirect exact from="/login" component={Login} />}
            {user && (
              <Route path="/PosMainScreen" exact component={PosMainScreen} />
            )}
            {user && <Route path="/qr-scan-report" exact component={QrScanReport} />}
          </Switch>
          {user && <Footer />}
        </SnackbarProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
